module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-pic01-111e1f069e222447944a3f91d362212c.png";